/**
 * Shared suburb/postcode -> delivery zone -> price lookup.
 * Reads window.LSDeliveryZoneData (snippets/ls-delivery-zone-data.liquid) and
 * window.LSDeliveryZonePrices (same snippet, driven by Theme settings). Every
 * placement (cart, PDP checker, delivery checker section) calls
 * LSDeliveryLookup.lookup(value) so they can never disagree.
 */
window.LSDeliveryLookup = (function () {
  'use strict';

  var suburbIndex = null;

  function normalizeSuburb(str) {
    return String(str || '')
      .trim()
      .toLowerCase()
      .replace(/\bst\.?\b/g, 'saint')
      .replace(/\s+/g, ' ');
  }

  function isPostcode(str) {
    return /^\d{4}$/.test(String(str || '').trim());
  }

  function buildSuburbIndex() {
    if (suburbIndex) return suburbIndex;
    suburbIndex = {};
    var data = (window.LSDeliveryZoneData && window.LSDeliveryZoneData.suburbToZone) || {};
    Object.keys(data).forEach(function (suburb) {
      suburbIndex[normalizeSuburb(suburb)] = { zone: data[suburb], label: suburb };
    });
    return suburbIndex;
  }

  /**
   * @param {string} rawQuery - suburb name or 4-digit postcode, as typed.
   * @returns {null|{ok:false,query:string}|{ok:true,type:'suburb'|'postcode',label:string,zone:string,price:number}}
   *   null when the query is blank (nothing to look up yet).
   */
  function lookup(rawQuery) {
    var query = String(rawQuery || '').trim();
    if (!query) return null;

    var prices = window.LSDeliveryZonePrices || {};

    if (isPostcode(query)) {
      var postcodeMap = (window.LSDeliveryZoneData && window.LSDeliveryZoneData.postcodeToZone) || {};
      var zone = postcodeMap[query];
      if (!zone) return { ok: false, query: query };
      return { ok: true, type: 'postcode', label: query, zone: zone, price: prices[zone] };
    }

    var index = buildSuburbIndex();
    var match = index[normalizeSuburb(query)];
    if (!match) return { ok: false, query: query };
    return { ok: true, type: 'suburb', label: match.label, zone: match.zone, price: prices[match.zone] };
  }

  return {
    lookup: lookup,
    normalizeSuburb: normalizeSuburb,
    isPostcode: isPostcode
  };
})();
